import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Input } from "../../../../../common/Input";

const MaintenanceSalaryCombinationCodeAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [form, setForm] = useState({ code: "", amount: 0 });

  useEffect(() => {
    if (selectedItem) setForm({ ...selectedItem });
    else setForm({ code: "", amount: 0 });
  }, [selectedItem, isOpen]);

  const handleAmountChange = (val) => {
    // Regex: Only allow positive integers
    const cleaned = val.replace(/[^0-9]/g, "");
    setForm(prev => ({ ...prev, amount: cleaned === "" ? 0 : parseInt(cleaned, 10) }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3">
      <div className="bg-white w-full md:w-[400px] rounded-lg shadow-xl">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold">{selectedItem ? "Edit" : "Add"} Code</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer"><CloseIcon /></button>
        </div>

        <div className="p-6 space-y-4">
          <Input
            label="Code"
            isRequired={true}
            value={form.code}
            onChange={(e) => setForm({ ...form, code: e.target.value })}
            placeholder="Enter code"
          />
          {/* <Input
            label="Amount"
            isRequired={true}
            type="text" // Using text with regex to prevent 'e', '.', and '-' characters
            value={form.amount}
            onChange={(e) => handleAmountChange(e.target.value)}
            placeholder="Enter amount"
            className={}
          /> */}
        </div>

        <div className="flex justify-end space-x-2 p-5 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded border-none">Cancel</button>
          <button
            disabled={!form.code?.trim()}
            onClick={() => onSave(form)}
            className={`px-6 py-2 text-white rounded border-none ${!form.code?.trim() ? 'bg-gray-400' : 'bg-blue-600'}`}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceSalaryCombinationCodeAddEditModal;